module.exports = __webpack_public_path__ + "img/application-form.889fb04b.png";